import { TChartProps } from './types'

interface TContainerProps {
  y: string
  value: string
  className: string
}

const Container = ({ y, value, className }: TContainerProps) => (
  <g>
    <rect x="0" y={y} width="45" height="18" fill="white" rx="10" ry="10" />
    <text
      className={className}
      x="21"
      y={parseInt(y) + 10}
      fill="black"
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {value}
    </text>
  </g>
)

export const Chart = ({
  yourWeightGoal,
  textGoal,
  yourWeight,
  yourWeightInterim,
  ...props
}: TChartProps) => {
  return (
    <svg
      width="289"
      height="154"
      viewBox="0 0 289 154"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M228.094 111.661C263.632 133.256 270.41 151 270.41 151H20.0469V12.8925C20.0469 12.8925 63.8326 10.4459 94.9437 31.3066C126.055 52.1673 126.574 65.0095 154.861 82.3649C172.612 93.2551 192.556 90.0652 228.094 111.661Z"
        fill="#F4F4F4"
      />
      <line x1="10.9102" y1="150.5" x2="269.91" y2="150.5" stroke="#E0E0E0" strokeLinecap="round" />
      <line
        x1="10.9102"
        y1="81.4021"
        x2="269.91"
        y2="81.4021"
        stroke="#E0E0E0"
        strokeLinecap="round"
      />
      <line
        x1="10.9102"
        y1="12.3042"
        x2="269.91"
        y2="12.3042"
        stroke="#E0E0E0"
        strokeLinecap="round"
      />
      <path
        d="M267.573 148.646C267.573 148.646 260.872 131.204 225.737 109.977C190.602 88.7491 170.883 91.8847 153.334 81.18C125.367 64.1202 124.853 51.4968 94.0949 30.9915C63.3363 10.4861 20.0466 12.891 20.0466 12.891"
        stroke="url(#paint0_linear_208_4427)"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_208_4427)">
        <circle cx="263.5" cy="143" r="11" fill="#E0E0E0" />
        <circle cx="263.5" cy="143" r="8" fill="white" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.5 37C219.186 37 216.5 39.6863 216.5 43V76C216.5 79.3137 219.186 82 222.5 82H255.156L261.233 89.1376C262.031 90.0757 263.48 90.0757 264.279 89.1376L270.414 81.9308C273.294 81.4906 275.5 79.0029 275.5 76V43C275.5 39.6863 272.814 37 269.5 37H222.5Z"
        fill="#727277"
      />
      <text className="goal-weight" x="244.5" y="70" fill="white" textAnchor="middle">
        <tspan x="244.5" y="55">
          {textGoal}
        </tspan>
        <tspan x="246" y="73">
          {yourWeightGoal}
        </tspan>
      </text>
      <Container className="current-weight" y="5" value={yourWeight} />
      <Container className="intermediate-weight" y="71" value={yourWeightInterim} />
      <Container className="goal-weight" y="135" value={yourWeightGoal} />
      <defs>
        <linearGradient
          id="paint0_linear_208_4427"
          x1="20.0498"
          y1="12.8043"
          x2="268.522"
          y2="151.115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#67DEFF" />
          <stop offset="0.398635" stopColor="#85D07F" />
          <stop offset="0.643433" stopColor="#FFE81E" />
          <stop offset="1" stopColor="#FB5D5D" />
        </linearGradient>
        <clipPath id="clip0_208_4427">
          <rect width="22" height="22" fill="white" transform="translate(252.5 132)" />
        </clipPath>
      </defs>
    </svg>
  )
}
